/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Tolerance_SecondsInputs */



/**
* | output |
* | --- |
* | "Start Tolerance (Seconds)" |
*
* @param {Start_Tolerance_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const start_tolerance_seconds = /** @type {((inputs?: Start_Tolerance_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Tolerance_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tolérance de début (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Starttoleranz (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tolleranza di avvio (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Допуск начала (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tolerancia de inicio (segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启动容差（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始許容値（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ सहनशीलता (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tolerância de inicialização (segundos)")
	return /** @type {LocalizedString} */ ("Start Tolerance (Seconds)")
});